// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__y9I0J","formSpace":"styles_formSpace__CHFSi","actionButton":"styles_actionButton__DfF6+","actionIcon":"styles_actionIcon__ykiiu"};